import { styled, theme } from '../stitches.config';
import { rem } from '../util';
import { Spacer } from './spacer';

export const InputError = ({ error }: { error?: string }) => {
  return error ? <ErrorText>{error}</ErrorText> : <Spacer height={24} />;
};

const ErrorText = styled('span', {
  display: 'inline-block',
  color: theme.colors.red11,
  fontSize: rem(12),
  fontWeight: theme.fontWeights.medium,
  lineHeight: rem(16),
  paddingBlock: rem(4),
  paddingLeft: rem(8),
});
